import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberMask'
})
export class PhoneNumberMaskPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || value.length < 4) {
      return value;
    }
    const firstTwo = value.slice(0, 2);
    const lastTwo = value.slice(-2);
    const maskedSection = 'X'.repeat(value.length - 4);
    return `${firstTwo}${maskedSection}${lastTwo}`;
  }


}
